<template>
	<el-container>
		<el-main style="display: flex;flex-direction: column;justify-content: center;">
			<div style="width: 100%;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">语料标注</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<!-- <div class="search_box" style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;width: 100%;">
				
			</div> -->
			<div class="content" style="margin-top: 30px;width: 90%;display: flex;flex-direction: row;justify-content: space-between;align-items: flex-start;">
				<div class="content_left" style="display: flex;flex-direction: column;justify-content: center;width: 20%;">
					<el-button class="item_font" size="mini" style="width: 50%;" @click="addTopic">+新增话题</el-button>
					<div class="tree-scroller">
						<el-tree :data="themeLst"
						ref="topicTree"
						highlight-current :indent="18" 
						node-key="id" 
						:expand-on-click-node="false" 
						style="width: 20%;min-width: 200px;margin-top: 30px;" 
						@node-click="handleNodeClick"
						>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span :class="data.pId=='0'?'node_class1':'node_class2'" class="item_font">{{ node.label }}</span>
								<span>
									<el-button type="text" style="margin-left: 10px;" size="mini" @click="() => append(node,data)" class="item_font">新增</el-button>
									<el-button type="text" size="mini" @click="() => remove(node, data)" class="item_font">删除</el-button>
								</span>
							</span>
						</el-tree>
					</div>
					
				</div>
				<div class="content_right" style="display: flex;flex-direction: column;justify-content: center;width: 80%;">
					<div class="right_top" style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
						<div class="search_box" style="display: flex;flex-direction: row;align-items: center;justify-content: flex-start;">
							<span style="font: 14px Arial, Helvetica, sans-serif;width: 2.5rem;text-align: left;" class="item_font">过滤</span>
							<el-input
								style="width: 400px;margin-left: 2%;"
								size="mini"
								placeholder="输入关键词搜索"
								suffix-icon="el-icon-search"
								v-model="searchData"
								@input="inputNothing"
							></el-input>
						</div>
						<div class="top_right">
							<el-button type="primary" size="mini" @click="transfer" class="item_font">转移</el-button>
							<el-button type="primary" size="mini" @click="addQuery" class="item_font">新增</el-button>
						</div>
					</div>
					<div class="corpusData" style="margin-top: 30px;display: flex;flex-direction: row;justify-content: space-between;align-items: flex-start;">
						<div class="table_page" style="display: flex;flex-direction: column;justify-content: flex-start;align-items: center;width: 100%;">
							<el-table :data="corpusData" :header-cell-style="headerStyle" border :cell-style="cellStyle" :max-height="500" style="width: 100%;"  @selection-change="handleSelectionChange">
								<el-table-column type="selection" width="55" class="item_font"></el-table-column>
								<el-table-column prop="count" label="搜索次数" class="item_font"></el-table-column>
								<el-table-column prop="query" label="搜索语料" class="item_font"></el-table-column>
								<el-table-column prop="keyword" label="搜索关键词" class="item_font"></el-table-column>
							</el-table>
							<div style="display: flex;flex-direction: row;width: 60%;margin-left: 10%;margin-top: 3%;justify-content: space-around;">
								<el-pagination background :pager-count='9' :page-size="100" layout="prev, pager, next, total" :total="total"
								@prev-click="pre" @next-click="next" @current-change="handleCurrentChange"> </el-pagination>
							</div>
						</div>
					</div>
				</div>
				
			</div>
			<div v-show="theme">
				<el-dialog title="新增话题" :visible.sync="theme" :close-on-click-modal="false" :close-on-press-escape="false" width="30%" center>
					<div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
						<div class="item_font">话题名字:</div>
						<el-input v-model="addTopicForm.name" style="width: 180px;margin-left: 10px;" size="medium"></el-input>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="theme = false" class="item_font">取 消</el-button>
						<el-button type="primary" @click="confirm(1)" class="item_font">确 定</el-button>
					</div>
				</el-dialog>
			</div>
			<div v-show="trf">
				<el-dialog title="话题选择" :visible.sync="trf" :close-on-click-modal="false" :close-on-press-escape="false" width="30%" center>
					<div style="width: 80%;margin: 0 auto;" class="item_font">
						<!-- <el-cascader-panel v-model="value" :options="themeLst" @change="handleChange"></el-cascader-panel> -->
						<el-table
						:data="themeLst" 
						style="width: 100%;" 
						:cell-style="cellStyle2" 
						height="300" 
						row-key="id"
						@row-click="checkUser" 
						:row-class-name="tableRowClassName"
						:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
						:indent="10">
							<el-table-column prop="name" label="" min-width="20%" row-key="id" ></el-table-column>
						</el-table>
						<!-- <el-cascader :props="props" v-model="value" :options="themeLst" @change="handleChange"></el-cascader> -->
					</div>
	
				</el-dialog>
			</div>
			<div v-show="adq">
				<el-dialog title="语料选择" :visible.sync="adq" :close-on-click-modal="false" :close-on-press-escape="false" width="50%" center>
					<div style="width: 90%;margin:20px auto;display: flex;flex-direction: row;justify-content: center;align-items: center;">
						<el-table stripe :data="tableData" border highlight-current-row style="width: 100%" height="400" :header-cell-style="headerStyle1" :cell-style="cellStyle1" @selection-change="handleSelectionChange1">
							<el-table-column type="selection" width="55"> 
							</el-table-column>
							<el-table-column  property="query" label="搜索语料">
							</el-table-column>
						</el-table>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="adq = false" class="item_font">取 消</el-button>
						<el-button type="primary" @click="confirm(2)" class="item_font">确 定</el-button>
					</div>
				</el-dialog>
			</div>
		</el-main>
	</el-container>
</template>

<script>
import {MessageBox} from 'element-ui';
export default {
	name: 'corpus',
	data() {
		return {
			searchData: '',
			myHeaders:{Authorization:localStorage.getItem("token")},
			corpusDataValue: '1',
			tabIndex: 2,
			overIndex: 0,
			themeLst:[],
			corpusData: [],
			seclectLst:[],
			checkTopicId:"",
			total:0,
			clickedTopicData:{
				id:"0",
				query:"",
				keyword:"",
				topicId:"",
				userId:this.util.getLocalAccount().id,
				source:"",
				current:1,
				size:100
			},
			theme:false,
			trf:false,
			adq:false,
			value: [],
			tableData:[],
			seclectLst1:[],
			name:'name',
			checkIds:[],
			startTopic:"",
			addTopicForm:{
				id:"",
				name:"",
				userId:this.util.getLocalAccount().id,
				pid:"0",
			},
			deleteTopicForm:{
				id:"",
				name:"",
				userId:this.util.getLocalAccount().id,
				pid:""
			},
			corpuSelectForm:{
					id:"",
					query:"",
					keyword:"",
					topicId:"",
					userId:this.util.getLocalAccount().id,   
					source:"",
					current:1,
					size:100
				},
		};
	},
	mounted(){
		this.topicSelect()
		console.log(this.util.getLocalAccount().id)
	},
	methods: {
		inputNothing(value) {
			console.log('输入搜索关键词', value);
			this.clickedTopicData.topicId=""
			this.clickedTopicData.keyword=this.searchData
			this.clickTopicIdSelect()
		},
		headerStyle({rowIndex,columnIndex }) {
			if (rowIndex==0&&columnIndex==1) {
				return 'text-align:left;padding:15px;color:#000000';
			} else {
				return 'text-align:center;color:#000000';
			}
		},
		cellStyle({columnIndex }) {
			if (columnIndex != 0) {
				return 'text-align:left;padding:15px;';
			} else {
				return 'text-align:center;';
			}
		},
		cellStyle2() {
			return 'text-align:left;height:20px;line-height:20px'
		},
		// 新增主题
		addTopic() {
			this.theme=true
		},
		append(node,data){
			this.theme=true
			this.addTopicForm.pid=data.id
			console.log(data.id)
		},
		// 删除主题
		async remove(node, data){
			const text = '是否确认删除'
			MessageBox.alert(text, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
				showCancelButton: true,
			}).then(()=>{
				this.deleteTopic(data)
			}).catch(()=>{
				this.$message.info("取消删除")
			})
	
		},
		async deleteTopic(data){
			this.deleteTopicForm.id=data.id
			this.deleteTopicForm.name=data.label
			this.deleteTopicForm.pid=data.pid
			var api = "/manager/topic/del"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data: this.deleteTopicForm
			})
			if(response.resultCode=="10000"){
				this.topicSelect()
				
			}else{
				this.$message.error(response.desc)
			}
		},
		
		// 查询主题
		async topicSelect() {
			var api = "/manager/topic/selectTree"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data: {
					userId:this.util.getLocalAccount().id
				}
			})
			if(response.resultCode=="10000"){
				for(var i = 0; i < response.data.length; i++){
						this.getTree(response.data[i])
				}
				this.themeLst=response.data
				if(this.startTopic==""){
					this.startTopic=response.data[0].id
					this.$nextTick().then(()=>{
						const firstNode = document.querySelector('.el-tree-node')
						firstNode.click()
					})
				}
			}

		},
		
		getTree(data){
			data.label = data.name
			data.value = data.name
			// data.pid = data.pid
			if(data.children!=null){
				for(var i = 0; i < data.children.length; i++) {
					this.getTree(data.children[i])
				}
			}
		},
		
		// 点击树节点展示数据
		handleNodeClick(data){
			this.clickedTopicData.topicId=data.id
			this.clickTopicIdSelect()
		},
		async clickTopicIdSelect(){
			var api = "/manager/corpus/select"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data: this.clickedTopicData
			})
			if(response.resultCode=="10000"){
				this.corpusData = response.data.data.corpusSelectVoList
				this.total=response.data.data.total
			}
		},
		
		// 分页相关方法
		pre(info) {
			console.log("pre：", info)
			this.clickedTopicData.current=info
			this.clickTopicIdSelect()			
		},
		next(info) {
			console.log("next：", info)
			this.clickedTopicData.current=info
			this.clickTopicIdSelect()
		},
		handleCurrentChange(val) {
			this.start = 4 * (val - 1)
			this.clickedTopicData.current=val
			this.clickTopicIdSelect()
		},
		
		
		handleSelectionChange(rows) {
			console.log("handleSelectionChange",rows)
			this.seclectLst=rows
		},
		// 转移语料
		transfer() {
			if(this.seclectLst.length===0){
				this.open2()
			}else{
				this.trf=true
			}
		},
		open2() {
			const text = '请选择要转移的数据'
			MessageBox.alert(text, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: null,
				type: "warning",
				showCancelButton: false,
			});
		},
		
		
		// 转移语料至新话题
		tableRowClassName ({row, rowIndex}) {
			row.index = rowIndex;
		},
		checkUser(row) {
			console.log("*** checkUser ***",row)
			// console.log("@@@ checkHistory @@@",column)
			// console.log("### checkHistory ###",event)
			this.checkTopicId = row.id
			console.log(this.checkTopicId)
			for(var i = 0; i < this.seclectLst.length; i++){
					this.checkIds.push(this.seclectLst[i].id)
				}
			MessageBox.alert("是否确认", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
				showCancelButton: true,
			}).then(()=>{
				this.clickMrark(this.checkIds)
			}).catch(()=>{
				this.$message.info("取消标注")
				this.checkIds=[]
			})
		},
		async clickMrark(list){
			
			if(this.checkTopicId!=""){
				this.corpusMark(list)
			}else{
				MessageBox.alert("话题不能为空", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: null,
					type: "warning",
					showCancelButton: false,
				}).then(()=>{
					this.checkIds=[]
				})
			}
		},
		async corpusMark(list){
			var api = "/manager/corpus/mark"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data:{
					topicId:this.checkTopicId,
					corpusIds:list
				}
			})
			if(response.resultCode=="10000"){
				this.trf=false
				this.checkIds=[]
				this.clickTopicIdSelect()
				
			}else{
				this.$message.error(response.desc)
			}
		},
		
		// 给话题增加新的语料
		addQuery() {
			console.log("Add Query Data Start----")
			this.adq=true
			this.corpuSelect()
		},
		// 查询尚未标记的语料
		async corpuSelect(){
			var api = "/manager/corpus/select"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data:this.corpuSelectForm
			})
			this.tableData=response.data.data.corpusSelectVoList
			for(var i = 0; i < this.tableData.length; i++){
				if(this.tableData[i].source==1){
					this.tableData[i].source="百度"
					this.tableData[i].createTime = this.tableData[i].createTime.replace("T"," ").replace(".000+0000","")
				}
			}
		},
		
		handleSelectionChange1(rows) {
			console.log("handleSelectionChange",rows)
			this.seclectLst1=rows
		},
		async confirm(num){
			// 1:新增子话题，2新增语料
			if(num===1){
				if(this.addTopicForm.name!=""){
					var api = "/manager/topic/edit"
					const response = await this.util.postRequest({
						itype:"1",
						url: api,
						method: "POST",
						data:this.addTopicForm
					})
					
					if(response.resultCode==="10000"){
						this.theme=false
						this.topicSelect()
						this.addTopicForm={
							id:"",
							name:"",
							userId:this.util.getLocalAccount().id,
							pid:"0",
						}
					}else{
						this.$message.error(response.desc)
					}
				}else{
					MessageBox.alert("话题名不能为空", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: null,
						type: "warning",
						showCancelButton: false,
					})
				}
				
			}else if(num===2){
				for(var i = 0; i < this.seclectLst1.length; i++){
					this.checkIds.push(this.seclectLst1[i].id)
				}
				this.checkTopicId = this.clickedTopicData.topicId
				MessageBox.alert("是否确认新增", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(()=>{
					this.clickMrark(this.checkIds)
					this.adq=false
				}).catch(()=>{
					this.$message.info("取消标注")
					this.checkIds=[]
				})
			}
			
		},
		
		headerStyle1({columnIndex}) {
			if(columnIndex===1){
				return 'text-align:left;color:#000000;'
			}else if(columnIndex===0){
				return 'text-align:right;border-right:none;padding-right:5px;'
			}else{
				return 'text-align:left;padding:15px;color:#000000;'
			}
		},
		cellStyle1({columnIndex}) {
			if(columnIndex===1){
				return 'text-align:left;'
			}else if(columnIndex===0){
				return 'text-align:right;border-right:none;padding-right:0;'
			}else{
				return 'text-align:left;padding:15px;'
			}
		},
	}
};
</script>

<style scoped="scoped" lang="scss">
.radios {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	height: 30px;
	line-height: 30px;
	margin-top: 30px;
	font-size: 14px;
}

.node_class1{
		font-size: 16px;
		/* font-weight: 550; */
	}
.node_class2{
	font-size: 14px;
}

.tree-scroller{
		height: 37.5rem;
		overflow: -moz-scrollbars-none;
		overflow: -moz-scrollbars-none;
		overflow-y: scroll;
	}
	
.tree-scroller::-webkit-scrollbar{
	display: none;
}
</style>
